<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:30%" label="权限值" type="text" id="code" v-model="form.code" placeholder="请输入权限值"/>
                        <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:30%" label="名称" type="text" id="name" v-model="form.name" placeholder="请输入名称"/>
                        <a-space style="margin: 0 0 0 0.5rem">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
                </div>
            </form>
        </div>
        <Tablelist :showCheckbox="false" :list="list" :columns="tableColumns"/>
    </div>

</template>

<script>
import { fetchList } from "@/api/setting/permission";

export default {
  data() {
    return {
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      tableColumns: [
        {
            key: 'name',
            title: '姓名',
            field: 'name',
            infotype: 'text'
        },
        {
            key: 'code',
            title: '权限值',
            field: 'code',
            infotype: 'text'
        },
        {
            key: 'group',
            title: '所属组',
            field: 'groupName',
            infotype: 'text',
        },
        {
            key: 'path',
            title: '接口路径',
            field: 'path',
            infotype: 'text',
        },
        {
            key: 'remarks',
            title: '备注',
            field: 'remarks',
            infotype: 'text',
        }
    ],
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      this.loading = true;
      const { current, pageSize } = this;
      fetchList({
        pageNum: current,
        pageSize,
        ...this.form,
      })
        .then((res) => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },
  },
};
</script>
<style scoped>
.logQuery{
    display: flex;
    justify-content: start;
    width: 70%;
}
::v-deep .input-container{
    padding: 0;
}
</style>